import React from "react";
import { Link } from "react-router-dom";
import { KINDSOFXCEED } from "../../data/XceedKinds";
import styles from "./XceedInfo.module.css";
function XceedInfo() {
  return (
    <div>
      <div className={`${styles.xceedInfoContainer}`}>
        <h1 className={`${styles.xceedInfoHeader}`}>XCEED</h1>
        <br />
        <p className={`${styles.xceedInfoDescription}`}>
          Launched in 2008, Xceed is Kurukshetra's outreach arm, taking the fest
          beyond Chennai to premier institutions, corporates, and schools. From
          robotics battles and coding marathons to managerial challenges, it
          ensures nationwide participation and often serves as a gateway to
          Kurukshetra finals. Hosted in IITs, IIMs, NITs, and more, Xceed
          extends the fest's reach and impact.
        </p>
      </div>
      <div className={`${styles.xceedTypeContainer}`}>
        {KINDSOFXCEED.map((kind, index) => {
          return <XceedKind key={index} kind={kind} />;
        })}
      </div>
      <div className={styles.mapSection}>
        <h2 className={styles.mapHeader}>Where We've Been</h2>
        <div className={styles.mapContainer}>
          <iframe
            src="https://www.google.com/maps/d/u/5/embed?mid=13_4MbVADQtrq1YgqlS7SRilAI4AfCIw&ehbc=2E312F&noprof=1"
            title="Xceed Event Locations"
            loading="lazy"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
}

const XceedKind = ({ kind }) => {
  return (
    <div className={`${styles.xceedTypeCard}`}>
      <Link to={`/xceed/${kind.link}`}>
        <img
          src={kind.image}
          alt={kind.name}
          className={`${styles.xceedTypeYearWiseImage}`}
        />

        {/* Type of xceed */}
        <h2 className={`${styles.xceedTypeTitle}`}>{kind.name}</h2>

        {/* About that particular xceed type */}
        <p className={`${styles.xceedTypeDescription}`}>{kind.description}</p>
      </Link>
    </div>
  );
};

export default XceedInfo;
